import "./application"

import { application } from "~/controllers/application"
import { registerControllers } from "stimulus-vite-helpers"

const controllers = import.meta.glob(
  [
    "./**/*_controller.js",
    "!./blocks/**/*_controller.js",
    "!./application/**/*_controller.js"
  ],
  { eager: true }
)
registerControllers(application, controllers)
